// import { PublicClientApplication } from "@azure/msal-browser";

const postLogoutRedirectUri = `${window.location.origin}${window.okta.logoutUri}`;

const msalConfig = {
  auth: {
    clientId: window.okta.clientId,
    authority: window.okta.issuer + window.okta.tenantId,
    postLogoutRedirectUri: postLogoutRedirectUri
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

const msalInstance = new msal.PublicClientApplication(msalConfig);


const initializeMsal = async () => {
  await msalInstance.initialize();
  //const account = msalInstance.getAllAccounts()[0];
};

export {
    initializeMsal,
    msalInstance
}

